import * as React from 'react';
import { useEffect, useState } from 'react';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { RootState } from '../../store';
import { LoginState } from '../../store/login/reducer';
import { BounceLoader } from 'react-spinners';
import styles from '../../Loading.module.scss';
//tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../utils/translations/translator';
import { toast } from 'react-toastify';

export interface StateProps {
  loginState: LoginState;
}

export const IPBasedRedirect: React.FC<StateProps> = ({ loginState }) => {
  const { t } = useTranslation();
  const [redirect, setRedirect] = useState<string | undefined>(undefined);
  const buildRedirectURL = (userID: string, country: string) => {
    const URLS = {
      grupoMiami: {
        ES: `https://promo.tipsterchat.com/grupomiami_es?user_id=${userID}`,
        MX: `https://promo.tipsterchat.com/grupomiami_mx?user_id=${userID}`,
        BR: `https://promo.tipsterchat.com/grupomiami_br?user_id=${userID}`,
        PE: `https://promo.tipsterchat.com/grupomiami_latam?user_id=${userID}`,
        CL: `https://promo.tipsterchat.com/grupomiami_latam?user_id=${userID}`,
        CO: `https://promo.tipsterchat.com/grupomiami_ot?user_id=${userID}`,
        PT: `https://promo.tipsterchat.com/grupomiami_ot?user_id=${userID}`,
        other: `https://promo.tipsterchat.com/grupomiami_ot?user_id=${userID}`,
      },
      grupoBarcelona: {
        ES: `https://promo.tipsterchat.com/grupobarcelona_es?user_id=${userID}`,
        MX: `https://promo.tipsterchat.com/grupobarcelona_mx?user_id=${userID}`,
        BR: `https://promo.tipsterchat.com/grupobarcelona_br?user_id=${userID}`,
        PE: `https://promo.tipsterchat.com/grupobarcelona_pe?user_id=${userID}`,
        CL: `https://promo.tipsterchat.com/grupobarcelona_ch?user_id=${userID}`,
        CO: `https://promo.tipsterchat.com/grupobarcelona_co?user_id=${userID}`,
        PT: `https://promo.tipsterchat.com/grupobarcelona_pt?user_id=${userID}`,
        other: `https://promo.tipsterchat.com/grupobarcelona_ot?user_id=${userID}`,
      },
      batallamadrid: {
        ES: `http://promo.tipsterchat.com/batallamadrid_es?user_id=${userID}`,
        MX: `http://promo.tipsterchat.com/batallamadrid_mx?user_id=${userID}`,
        BR: `http://promo.tipsterchat.com/batallamadrid_br?user_id=${userID}`,
        PR: `http://promo.tipsterchat.com/batallamadrid_pt?user_id=${userID}`,
        CO: `http://promo.tipsterchat.com/batallamadrid_co?user_id=${userID}`,
        PE: `http://promo.tipsterchat.com/batallamadrid_pe?user_id=${userID}`,
        CL: `http://promo.tipsterchat.com/batallamadrid_chi?user_id=${userID}`,
        other: `http://promo.tipsterchat.com/batallamadrid_ot?user_id=${userID}`,
      },
      captura: {
        other: `https://promo.tipsterchat.com/captura?user_id=${userID}`,
      },
      lasvegas: {
        ES: `http://promo.tipsterchat.com/lasvegas_es?user_id=${userID}`,
        MX: `http://promo.tipsterchat.com/lasvegas_mx?user_id=${userID}`,
        BR: `http://promo.tipsterchat.com/lasvegas_br?user_id=${userID}`,
        PT: `http://promo.tipsterchat.com/lasvegas_pt?user_id=${userID}`,
        CL: `http://promo.tipsterchat.com/lasvegas_co?user_id=${userID}`,
        PE: `http://promo.tipsterchat.com/lasvegas_pe?user_id=${userID}`,
        CH: `http://promo.tipsterchat.com/lasvegas_chi?user_id=${userID}`,
        other: `http://promo.tipsterchat.com/lasvegas_ot?user_id=${userID}`,
      },
      premiummallicwinners: {
        ES: `http://promo.tipsterchat.com/premiumgratis_es?user_id=${userID}`,
        MX: `http://promo.tipsterchat.com/premiumgratis_mx?user_id=${userID}`,
        BR: `http://promo.tipsterchat.com/premiumgratis_br?user_id=${userID}`,
        PT: `http://promo.tipsterchat.com/premiumgratis_pt?user_id=${userID}`,
        CO: `http://promo.tipsterchat.com/premiumgratis_co?user_id=${userID}`,
        GB: `http://promo.tipsterchat.com/premiumgratis_uk?user_id=${userID}`,
        AR: `http://promo.tipsterchat.com/premiumgratis_latam?user_id=${userID}`,
        PE: `http://promo.tipsterchat.com/premiumgratis_latam?user_id=${userID}`,
        EC: `http://promo.tipsterchat.com/premiumgratis_latam?user_id=${userID}`,
        VE: `http://promo.tipsterchat.com/premiumgratis_latam?user_id=${userID}`,
        CL: `http://promo.tipsterchat.com/premiumgratis_latam?user_id=${userID}`,
        other: `http://promo.tipsterchat.com/premiumgratis_other?user_id=${userID}`,
      },
      retousopenx10: {
        ES: `https://promo.tipsterchat.com/retousopen_es?user_id=${userID}`,
        MX: `https://promo.tipsterchat.com/retousopen_mx?user_id=${userID}`,
        other: `https://promo.tipsterchat.com/retousopen_ot?user_id=${userID}`,
      },
      'acceso-gratis-retoatpfinals-es': {
        other: `https://promo.tipsterchat.com/reto-atpfinals-es?user_id=${userID}`,
      },
      'acceso-gratis-retoatpfinals-mx': {
        other: `https://promo.tipsterchat.com/reto-atpfinals-mx?user_id=${userID}`,
      },
      'acceder-reto-navidad': {
        ES: 'https://www.tipsterchat.com/shop/cm22lc3511im1itn4jt0',
        MX: `https://promo.tipsterchat.com/reto-navidad-mx?user_id=${userID}`,
        other: 'https://www.tipsterchat.com/shop/cm22lc3511im1itn4jt0',
      },
    };

    Object.keys(URLS).map((key) => {
      if (window.location.href.includes(key)) {
        const group = key;
        //@ts-ignore
        const res = URLS[group][country] || URLS[group]['other'];
        setRedirect(res);
        return;
      }
    });
  };
  const buildCustomRedirectURL = (
    country: string,
    URLcode: string,
    userID?: string,
  ) => {
    const URLS = {
      reto_blackfriday: {
        ES: userID
          ? `https://promo.tipsterchat.com/reto_blackfriday?user_id=${userID}&code=${URLcode}`
          : `https://promo.tipsterchat.com/reto_blackfriday?code=${URLcode}`,
        MX: userID
          ? `https://promo.tipsterchat.com/reto_blackfriday_mx?user_id=${userID}&code=${URLcode}`
          : `https://promo.tipsterchat.com/reto_blackfriday_mx?code=${URLcode}`,
        other: `https://promo.tipsterchat.com/reto_blackfriday_ot`,
      },
    };

    Object.keys(URLS).map((key) => {
      if (window.location.href.includes(key)) {
        const group = key;
        //@ts-ignore
        const res = URLS[group][country] || URLS[group]['other'];
        setRedirect(res);
        return;
      }
    });
  };

  useEffect(() => {
    const country = get(loginState, ['user', 'user', 'country_code']);
    const userID = get(loginState, ['user', 'user', 'id']);

    if (window.location.href.includes('reto_blackfriday')) {
      const currentUrl = window.location.href;
      var url = new URL(currentUrl);
      var URLcode = url.searchParams.get('code');
      if (!URLcode) {
        toast.error('invalid code');
        throw Error('invalid code');
      }
      buildCustomRedirectURL(country, URLcode, userID);
      return;
    }
    buildRedirectURL(userID, country);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (redirect) {
      window.location.href = redirect;
    }
  }, [redirect]);

  return (
    <div>
      {!redirect ? (
        <div className={styles.loadingWrapper}>
          <div className={styles.loading}>
            <BounceLoader color={'#6633ff'} size={25} />
            <label>{tr(t, 'loading')} ...</label>
          </div>
        </div>
      ) : (
        <div className={styles.loadingWrapper}>
          <div className={styles.loading}>
            <BounceLoader color={'#6633ff'} size={25} />
            <label>{tr(t, 'loading')} ...</label>
          </div>
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  loginState: state.login,
});

export const IPBasedRedirectConnected =
  connect(mapStateToProps)(IPBasedRedirect);
